import Vue from 'vue'
import Router from 'vue-router'

import Auth from '@/common/auth'

import Template from '@/template/index'
import Home from '@/views/home'
import Authorized from '@/views/authorized'
import TrocarEscola from '@/views/trocarescola'
import AcessoNegado from '@/views/acessonegado'
import Configuracao from '@/views/estagio/configuracao'

import routersgenerated from './generated'

Vue.use(Router)

let childrens = routersgenerated.concat([
    {
        path: 'home',
        name: 'Home',
        component: Home
    },
    {
        path: '/estagio/configuracao/:id',
        name: 'configuracao',
        component: Configuracao,
    },
]);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/authorized',
            name: 'authorized',
            component: Authorized,
        },
        {
            path: '/trocarescola',
            name: 'trocarescola',
            component: TrocarEscola,
        },
        {
            path: '/acessonegado',
            name: 'acessonegado',
            component: AcessoNegado,
        },
        {
            path: '/',
            redirect: '/home',
            component: Template,
            meta: { requiresAuth: true },
            children: childrens
        },
    ]
})

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {

        if (!Auth.logged()) {
            Auth.login(true);
            return;
        }

        if (!Auth.canAccess(to.path)) {
            next('/acessonegado')
            return;
        }
    }
    next();
});


export default router;
